const ApiUrl = {
    // Auth Url
    login: "users/api/v1/auth/login",
    forgotPassword: "users/api/v1/auth/forgot-password",
    verifyOtp: "users/api/v1/auth/verify-otp",
    resetPassword: "users/api/v1/auth/reset-password",
    // User Details Url
    userList: "users/api/v1/user/user-list",
    listLog: "core/api/list-log",



    // Roles and Managements Url
    createRole: "users/api/v1/roles",
    getRole: "users/api/v1/roles",
    updateRole: "users/api/v1/update-role",
    deleteRole: "users/api/v1/delete-role",


    // Loan and Investment
    getIntrestRate:"core/api/interest-rates",
    createInterestRate:"core/api/interest-rates/create",
    updateInterestRate:"core/api/interest-rates/update",
    deleteInterestRate:"core/api/interest-rates/delete",

    // Users
    createUser:"users/api/v1/admin/create-web-user",
    getUser: 'users/api/v1/admin/get-web-users',
    updateUser:'users/api/v1/admin/update-web-user',
    deleteUser:"users/api/v1/admin/delete-web-user",

    //
    getSupportTicket:"users/api/v1/support-tickets",
    updateSupportTicket:"users/api/v1/support-tickets/update",


    // users/api/v1
    assignWebUser:"users/api/v1/support-tickets/assign-web-user",
    // Notification
    notificationList:"users/api/v1/notification",
    notificationUpdate:"users/api/v1/notification/update"
  };
  
  export default ApiUrl;
  